module.exports = __webpack_public_path__ + "img/logo-mercadopago.61bcbf9f.svg";